/**
 * @generated SignedSource<<4d39b5c8d78db4a37794a5a7bf29b37d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QboPnlLineDrillEnum = "COGS" | "GROSS_PROFIT" | "NET_INCOME" | "OTHER_OPEX" | "REVENUE" | "%future added value";
export type qboPnlCellPanel_Query$variables = {
  fiscalYear: number;
  limit?: number | null | undefined;
  line: QboPnlLineDrillEnum;
  offset?: number | null | undefined;
  sort?: string | null | undefined;
  sortDirection?: string | null | undefined;
};
export type qboPnlCellPanel_Query$data = {
  readonly qboPnlCell: {
    readonly limit: number;
    readonly rows: ReadonlyArray<{
      readonly accountName: string | null | undefined;
      readonly amount: number;
      readonly counterparty: string | null | undefined;
      readonly docNum: string | null | undefined;
      readonly entityType: string | null | undefined;
      readonly groupKey: string;
      readonly id: string;
      readonly memo: string | null | undefined;
      readonly splitAccount: string | null | undefined;
      readonly txnDate: string | null | undefined;
    }>;
    readonly staged: boolean;
    readonly totalAmount: number;
    readonly totalCount: number;
  };
};
export type qboPnlCellPanel_Query = {
  response: qboPnlCellPanel_Query$data;
  variables: qboPnlCellPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fiscalYear"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "line"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v6 = [
  {
    "kind": "Variable",
    "name": "fiscalYear",
    "variableName": "fiscalYear"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "line",
    "variableName": "line"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staged",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "QboPnlDetailRow",
  "kind": "LinkedField",
  "name": "rows",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "txnDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "docNum",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "counterparty",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "splitAccount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "qboPnlCellPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "QboPnlCell",
        "kind": "LinkedField",
        "name": "qboPnlCell",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "qboPnlCellPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "QboPnlCell",
        "kind": "LinkedField",
        "name": "qboPnlCell",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v12/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "446719be7594a58360b4a476b26c066f",
    "id": null,
    "metadata": {},
    "name": "qboPnlCellPanel_Query",
    "operationKind": "query",
    "text": "query qboPnlCellPanel_Query(\n  $line: QboPnlLineDrillEnum!\n  $fiscalYear: Int!\n  $limit: Int\n  $offset: Int\n  $sort: String\n  $sortDirection: String\n) {\n  qboPnlCell(line: $line, fiscalYear: $fiscalYear, limit: $limit, offset: $offset, sort: $sort, sortDirection: $sortDirection) {\n    staged\n    totalCount\n    totalAmount\n    limit\n    rows {\n      id\n      txnDate\n      entityType\n      docNum\n      counterparty\n      memo\n      splitAccount\n      accountName\n      groupKey\n      amount\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "801971d10ee77f8acbc9f0ee56652e71";

export default node;
